import React from "react";
import { Modal, Radio, Form, Space, Row, Col } from "antd";
import {
  DatePickerTimeComponent,
  DatePickerWeekComponent,
} from "../../component/DatePickerComponent";
import * as service from "../../service";

const HistoryWeekModal = ({ historyWeekModalRef, ...props }) => {
  const [form] = Form.useForm();
  const [visible, changeVisible] = React.useState(false);
  const [data, changeData] = React.useState([]);
  // 暴露组件的方法
  React.useImperativeHandle(historyWeekModalRef, () => ({
    onOpen,
  }));
  const onOpen = () => {
    changeVisible(true);
    getData();
  };
  const onClose = () => {
    changeVisible(false);
  };
  const getData = async () => {
    const res = await service.getWeekActiveList({ pageSize: 100 });
    changeData(res.data.data);
  };
  const onSubmit = async () => {
    const values = await form.validateFields();
    console.log("values", values);
    const reqParams = data.find((ele) => ele.id === values.weekId);
    reqParams.weekNo = values.weekNo.weekNo;
    reqParams.weekDate = values.weekNo;
    reqParams.weekDays = values.weekNo.weekDays.join(",");
    reqParams.weekTimeBetween = `${values.weekNo.weekDays[0]} 至 ${values.weekNo.weekDays[6]}`;
    reqParams.children = reqParams.children.map((ele, index) => ({
      ...ele,
      lotteryStartTime: `${values.weekNo.weekDays[index]} ${values.lotteryStartTime}`,
      lotteryTime: `${values.weekNo.weekDays[index]} ${values.lotteryTime}`,
    }));
    props.onSubmit && props.onSubmit(reqParams);
    console.log("reqParams", reqParams);
    onClose();
  };
  return (
    <Modal title="复制往期" open={visible} onCancel={onClose} onOk={onSubmit}>
      <Form
        form={form}
        labelCol={{ span: 6 }}
        wrapperCol={{ span: 18 }}
        initialValues={{
          lotteryStartTime: "07:00:00",
          lotteryTime: "21:30:00",
          // weekNo: { weekNo: "2024-45周" },
        }}
      >
        <Form.Item label="周" name="weekNo" rules={[{ required: true }]}>
          <DatePickerWeekComponent />
        </Form.Item>
        <Form.Item
          label="每日开始时间"
          name="lotteryStartTime"
          rules={[{ required: true }]}
        >
          <DatePickerTimeComponent />
        </Form.Item>
        <Form.Item
          label="每日开奖时间"
          name="lotteryTime"
          rules={[{ required: true }]}
        >
          <DatePickerTimeComponent />
        </Form.Item>
        <Form.Item label="往期列表" name="weekId" rules={[{ required: true }]}>
          <Radio.Group>
            <Space direction="vertical">
              {data.map((ele) => (
                <Radio value={ele.id} key={ele.weekNo}>
                  第{ele.weekNo}期，{ele.weekTimeBetween}
                </Radio>
              ))}
            </Space>
          </Radio.Group>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default React.forwardRef(HistoryWeekModal);
